<template>
  <div class="invitepage">
    <div class="flex space-between pl10 pr20">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>展商邀请函</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="inviteMain">
      <div class="codeCons" v-if="ExhID == '9669'">
        <p style="margin-bottom：0;padding-bottom:4px">{{text.PsnQRCode}}</p>
        <p>专属邀约码，分享邀请观众</p>
        <div id="PsnQRCode"></div>
        <p style="font-size:12px; color:red; padding-top:10px;">请使用微信扫描二维码</p>
        <p @click="downs('PsnQRCode')"><span style="border:1px solid #333; border-radius: 3px; cursor: pointer; padding: 8px 12px; font-size:14px;">下载二维码</span></p>
        <div>{{ `http://mob.exporegist.com/24lfAt/index.html?SourceID=${userInfo.atrID}&Source=actor` }}</div>
      </div>

      <div class="codeCons" v-if="ExhID == '9668'">
        <p>{{text.PsnQRCode1}}</p>
        <div id="PsnQRCode1"></div>
        <p style="font-size:12px; color:red; padding-top:10px;">请使用微信扫描二维码</p>
        <p @click="downs('PsnQRCode1')"><span style="border:1px solid #333; border-radius: 3px; cursor: pointer; padding: 8px 12px; font-size:14px;">下载二维码</span></p>
        <div>{{ `http://mob.exporegist.com/24sjAt/index.html?SourceID=${userInfo.atrID}&Source=actor` }}</div>
      </div>

      <!-- <div class="codeCons">
       <p>{{text.PsnQRCode2}}</p>
        <div id="PsnQRCode2"></div>
        <p style="font-size:12px; color:red; padding-top:10px;">请使用微信扫描二维码</p>
        <p @click="downs('PsnQRCode2')"><span style="border:1px solid #333; border-radius: 3px; cursor: pointer; padding: 8px 12px; font-size:14px;">下载二维码</span></p>
        <div>{{ `http://mob.exporegist.com/23hsLive/index.html?SourceID=${userInfo.atrID}&Source=actor` }}</div>
      </div> -->


    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  name: 'invitePage',
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      ExhID:localStorage.getItem('ExhID') || '',
      text:{
        // PsnQRCode:"2024国际婚纱礼服，彩妆造型及时尚配饰展（上海）",
        PsnQRCode:'2024上海国际婚纱礼服、彩妆造型及时尚配饰展',
        // PsnQRCode1:"2024上海国际视觉影像产业展览会",
        PsnQRCode1:'专属邀约码，分享邀请观众',
        PsnQRCode2:"",
      }
    }
  },
  mounted() {
    if(this.ExhID == '9669'){
      document.getElementById('PsnQRCode').innerHTML = ''
      // 生成卡号二维码
      let PsnQRCode = new QRCode('PsnQRCode', {
        // eslint-disable-line
        width: 160,
        height: 160, // 高度
        colorDark: 'black', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        text: `http://mob.exporegist.com/24lfAt/index.html?SourceID=${this.userInfo.atrID}&Source=actor` // 二维码内容（只存储的卡号）
      })
    }


    if(this.ExhID == '9668'){
      document.getElementById('PsnQRCode1').innerHTML = ''
      // 生成卡号二维码
      let PsnQRCode1 = new QRCode('PsnQRCode1', {
        // eslint-disable-line
        width: 160,
        height: 160, // 高度
        colorDark: 'black', // 二维码颜色
        colorLight: '#ffffff', // 二维码背景色
        text: `http://mob.exporegist.com/24sjAt/index.html?SourceID=${this.userInfo.atrID}&Source=actor` // 二维码内容（只存储的卡号）
      })
    }

    // document.getElementById('PsnQRCode2').innerHTML = ''
    // // 生成卡号二维码
    // let PsnQRCode2 = new QRCode('PsnQRCode2', {
    //   // eslint-disable-line
    //   width: 160,
    //   height: 160, // 高度
    //   colorDark: 'black', // 二维码颜色
    //   colorLight: '#ffffff', // 二维码背景色
    //   text: `http://mob.exporegist.com/23hsLive/index.html?SourceID=${this.userInfo.atrID}&Source=actor` // 二维码内容（只存储的卡号）
    // })


  },
  methods: {
    downs(str) {
      var that = this
      // //找到canvas标签
      let myCanvas = document.getElementById(str).getElementsByTagName('canvas')
      let img = document.getElementById(str).getElementsByTagName('img')
      // // //创建一个a标签节点
      let a = document.createElement('a')
      // //设置a标签的href属性（将canvas变成png图片）
      let imgURL = myCanvas[0].toDataURL('image/jpg')
      let ua = navigator.userAgent
      if (ua.indexOf('Trident') != -1 && ua.indexOf('Windows') != -1) {
        // IE内核 并且  windows系统 情况下 才执行;
        var bstr = atob(imgURL.split(',')[1])
        var n = bstr.length
        var u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        var blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, '下载' + '.' + 'png')
      } else if (ua.indexOf('Firefox') > -1) {
        //火狐兼容下载
        let blob = this.base64ToBlob(imgURL) //new Blob([content]);
        let evt = document.createEvent('HTMLEvents')
        evt.initEvent('click', true, true) //initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
        a.download = ' ' //下载图片名称，如果填内容识别不到，下载为未知文件，所以我这里就不填为空
        a.href = URL.createObjectURL(blob)
        a.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })) //兼容火狐
      } else {
        //谷歌兼容下载
        img.src = myCanvas[0].toDataURL('image/jpg')
        // a.href = myCanvas[0].toDataURL('image/png').replace('image/png', 'image/octet-stream')
        a.href = img.src
        //设置下载文件的名字
        // a.download = that.text[str]
        a.download = '2024上海展会观众邀请渠道码'
        //点击
        a.click()
      }
    },
    //base64转blob
    base64ToBlob(code) {
      let parts = code.split(';base64,')
      let contentType = parts[0].split(':')[1]
      let raw = window.atob(parts[1])
      let rawLength = raw.length
      let uInt8Array = new Uint8Array(rawLength)
      for (let i = 0; i < rawLength; ++i) {
        uInt8Array[i] = raw.charCodeAt(i)
      }
      return new Blob([uInt8Array], { type: contentType })
    }
  }
}
</script>
<style lang="less" scoped>
.inviteMain {
  padding-top: 20px;
  text-align: center;
  .codeCons{
    width:50%;
    display: inline-block;
  }
  .codeCons > div {
    display: inline-block;
  }
  .codeCons p {
    font-size: 16px;
    padding-bottom: 20px;
    text-align: center;
  }
}
</style>
